/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Add"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Remove all"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enAU = Object.assign(TranslationProviderComponent, {
  translations
});

export { enAU as e };
//# sourceMappingURL=en-AU-DGGK0Lgs.js.map
